import React from "react";

/* Form & Form Validation */
import * as Yup from "yup";

import { Divider } from "antd";

import { Form, Input } from "formik-antd";

import { BasicForm } from "../../../../core/components/form";

const LoginSchema = Yup.object().shape({
    code: Yup.string().required("PoS Code cannot be blank."),
    name: Yup.string().required("PoS Name cannot be blank."),
    first_name: Yup.string().required("First Name cannot be blank."),
    last_name: Yup.string().required("Last Name cannot be blank."),
});

function validateRequired(value) {
    return value ? undefined : "required";
}

const Formulario = (props) => {
    const _goBack = () => {
        props.history.goBack();
    };

    const _initialForm = () => {
        const { alta, data, loaded } = props;

        if (!alta && loaded && data) {
            return {
                code: data.point_of_sale?.code,
                name: data.point_of_sale?.name,
                notes: data.point_of_sale?.notes,

                first_name: data.point_of_sale?.first_name,
                last_name: data.point_of_sale?.last_name,
                phone: data.point_of_sale?.phone,
                email: data.point_of_sale?.email,
                skype: data.point_of_sale?.skype,
            };
        } else {
            return {
                code: "",
                name: "",
                notes: "",

                first_name: data.project.first_name,
                last_name: data.project.last_name,
                phone: data.project.phone,
                email: data.project.email,
                skype: data.project.skype,
            };
        }
    };

    return (
        <BasicForm
            onPressBack={_goBack}
            titulo="Add Point Of Sale"
            initialValues={_initialForm()}
            validationSchema={LoginSchema}
            onSubmit={props.handleSubmit}
            render={({ isSubmitting, touched, errors, values }) => (
                <>
                    <Divider orientation="left" plain>
                        General Fields
                    </Divider>

                    <Form.Item
                        name="code"
                        label="POS Code"
                        required={true}
                        hasFeedback={true}
                        showValidateSuccess={true}
                        validate={validateRequired}
                    >
                        <Input name="code" />
                    </Form.Item>
                    <Form.Item
                        name="name"
                        label="POS Name"
                        required={true}
                        hasFeedback={true}
                        showValidateSuccess={true}
                        validate={validateRequired}
                    >
                        <Input name="name" />
                    </Form.Item>

                    <Form.Item name="notes" label="Notes">
                        <Input.TextArea name="notes" />
                    </Form.Item>

                    <Divider orientation="left" plain>
                        Primary Contact
                    </Divider>

                    <Form.Item
                        name="first_name"
                        label="First Name"
                        required={true}
                        validate={validateRequired}
                        hasFeedback={true}
                        showValidateSuccess={true}
                    >
                        <Input name="first_name" />
                    </Form.Item>

                    <Form.Item
                        name="last_name"
                        label="Last Name"
                        required={true}
                        validate={validateRequired}
                        hasFeedback={true}
                        showValidateSuccess={true}
                    >
                        <Input name="last_name" />
                    </Form.Item>
                    <Form.Item name="phone" label="Phone">
                        <Input name="phone" />
                    </Form.Item>
                    <Form.Item name="email" label="EMail">
                        <Input name="email" />
                    </Form.Item>
                    <Form.Item name="skype" label="Skype">
                        <Input name="skype" />
                    </Form.Item>
                    <Divider />
                </>
            )}
        />
    );
};

export default Formulario;
